"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Random = void 0;

var pure_rand_1 = require("pure-rand");

var PureRandom_1 = require("./PureRandom");

var Random = /*#__PURE__*/function () {
  function Random(sourceRng) {
    _classCallCheck(this, Random);

    this.internalRng = (0, PureRandom_1.convertToRandomGenerator)(sourceRng).clone();
  }

  _createClass(Random, [{
    key: "clone",
    value: function clone() {
      return new Random(this.internalRng);
    }
  }, {
    key: "next",
    value: function next(bits) {
      return (0, pure_rand_1.unsafeUniformIntDistribution)(0, (1 << bits) - 1, this.internalRng);
    }
  }, {
    key: "nextBoolean",
    value: function nextBoolean() {
      return (0, pure_rand_1.unsafeUniformIntDistribution)(0, 1, this.internalRng) == 1;
    }
  }, {
    key: "nextInt",
    value: function nextInt(min, max) {
      return (0, pure_rand_1.unsafeUniformIntDistribution)(min == null ? Random.MIN_INT : min, max == null ? Random.MAX_INT : max, this.internalRng);
    }
  }, {
    key: "nextBigInt",
    value: function nextBigInt(min, max) {
      return (0, pure_rand_1.unsafeUniformBigIntDistribution)(min, max, this.internalRng);
    }
  }, {
    key: "nextArrayInt",
    value: function nextArrayInt(min, max) {
      return (0, pure_rand_1.unsafeUniformArrayIntDistribution)(min, max, this.internalRng);
    }
  }, {
    key: "nextDouble",
    value: function nextDouble() {
      var a = this.next(26);
      var b = this.next(27);
      return (a * Random.DBL_FACTOR + b) * Random.DBL_DIVISOR;
    }
  }]);

  return Random;
}();

exports.Random = Random;
Random.MIN_INT = 0x80000000 | 0;
Random.MAX_INT = 0x7fffffff | 0;
Random.DBL_FACTOR = Math.pow(2, 27);
Random.DBL_DIVISOR = Math.pow(2, -53);